



















import {Component, Vue} from 'vue-property-decorator';
import AnimatedInput from "@/components/AnimatedInput.vue";
import LoadingButton from "@/components/LoadingButton.vue";
import Browsercheck from "@/components/Browsercheck.vue";
import AdminAdapter from "@/adapters/admin";

@Component({
  components: { AnimatedInput, LoadingButton, Browsercheck },
})
export default class ResetPasswordInit extends Vue {

  email: string = "";
  password: string = "";
  repeat: string = "";
  loading: boolean = true;
  adminAdapter: AdminAdapter = new AdminAdapter();

  async resetPassword() {

    try {
      await this.adminAdapter.initiatePasswordReset(this.email);
      this.$toast.success("Wenn deine Eingabe richtig war, erhältst du in den nächsten Minuten eine E-Mail!");
      this.$router.push("/");
    } catch (error) {
      if (error.response && error.response.status === 429) {
        this.$swal('Zu viele Anfragen', 'Bitte warte mindestens ' + error.response.data.message + ' Sekunden', 'error');
      } else {
        this.$toast.error("Ein Fehler ist aufgetreten. Bitte überprüfe deine Eingaben.");
      }
    }

  }
}
